import config from "../../config";
import { calculateLuminosity } from "./calculator";
import GreenDistance from "../../assets/SVG/icons/GreenDistance.svg";
import RedDistance from "../../assets/SVG/icons/RedDistance.svg";
import NoLight from "../../assets/SVG/icons/No-light.svg";
import GoodLight from "../../assets/SVG/icons/Good-light.svg";
import ErrorIcon from "../../assets/SVG/icons/error-icon.svg";

let gdistance = new Image();
let rdistance = new Image();
let noLightIcon = new Image();
let goodLightIcon = new Image();
let errorIcon = new Image();

gdistance.src = GreenDistance;
rdistance.src = RedDistance;
noLightIcon.src = NoLight;
goodLightIcon.src = GoodLight;
errorIcon.src = ErrorIcon;

const drawBrightnessBar = (canvasElement, ctx, lightingScore = 0, previousLightingScore = 0) => {
  let position = 0;
  let indicator = 0;
  let newLightingScore;

  if (Math.abs(lightingScore - previousLightingScore) > config.test.lighting_adjustment_threshold) {
    newLightingScore = lightingScore;
  } else {
    newLightingScore = previousLightingScore;
  }

  position = canvasElement.width / 3 + ((canvasElement.width / 3) * newLightingScore) / 100 - 17;
  indicator = 35 < newLightingScore && newLightingScore < 70 ? goodLightIcon : noLightIcon;

  let txt = "Too Dark";
  if (35 < newLightingScore) txt = "Normal";
  if (newLightingScore > 70) txt = "Too Bright";
  if (35 < newLightingScore && newLightingScore < 70) {
    ctx.fillStyle = "green";
  } else {
    ctx.fillStyle = "red";
  }
  ctx.save();
  ctx.translate(canvasElement.width, 0);
  ctx.scale(-1, 1);

  ctx.textAlign = "center";
  ctx.font = "24px century-gothic";
  ctx.fillText(txt, position + 17, canvasElement.height - 60);

  ctx.lineCap = "round";
  ctx.lineWidth = 10;

  ctx.strokeStyle = "#755E0D";
  ctx.beginPath();
  ctx.moveTo(canvasElement.width / 3, canvasElement.height - 35);
  ctx.lineTo(canvasElement.width / 3 + canvasElement.width / 9, canvasElement.height - 35);
  ctx.stroke();

  ctx.strokeStyle = "#FFEBA6";
  ctx.beginPath();
  ctx.moveTo(canvasElement.width / 3 + (2 * canvasElement.width) / 9, canvasElement.height - 35);
  ctx.lineTo(canvasElement.width / 3 + (3 * canvasElement.width) / 9, canvasElement.height - 35);
  ctx.stroke();

  ctx.lineCap = "butt";
  ctx.strokeStyle = "#FEC80A";
  ctx.beginPath();
  ctx.moveTo(canvasElement.width / 3 + canvasElement.width / 9, canvasElement.height - 35);
  ctx.lineTo(canvasElement.width / 3 + (2 * canvasElement.width) / 9, canvasElement.height - 35);
  ctx.stroke();

  ctx.drawImage(indicator, position, canvasElement.height - 50, 30, 30);
  ctx.restore();
};

const drawContours = async (
  webcamElement,
  canvasElement,
  xli,
  xri,
  yli,
  yri,
  radiusLeft,
  radiusRight,
  faceContour,
  distance,
  states
) => {
  const {
    lightingScore,
    previousLightingScore,
    counter,
    fixedCanvasWidth,
    fixedCanvasHeight,
    finalImageWidth,
    finalImageHeight,
    isLandscapeMode,
  } = states;
  const landscapeMode = isLandscapeMode ? true : false;

  if (webcamElement.videoWidth <= 0) {
    /* This condition will prevent the error of indexSize in drawtmage function */
    return;
  }
  canvasElement.width = fixedCanvasWidth;
  canvasElement.height = fixedCanvasHeight;

  let ctx = canvasElement.getContext("2d");

  // Drawing Iris
  if (xli && yli && radiusLeft && radiusRight) {
    ctx.beginPath();
    ctx.arc(xli, yli, radiusLeft, 0, 2 * Math.PI);
    ctx.lineWidth = "3";
    ctx.strokeStyle = distance ? "green" : "red";
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(xri, yri, radiusRight, 0, 2 * Math.PI);
    ctx.lineWidth = "3";
    ctx.strokeStyle = distance ? "green" : "red";
    ctx.stroke();
  }

  // Drawing Facial Contour
  if (faceContour && faceContour.length > 1) {
    for (let i = 0; i < faceContour.length - 1; i++) {
      ctx.beginPath();
      ctx.strokeStyle = distance ? "green" : "red";
      ctx.lineWidth = "3";
      ctx.moveTo(faceContour[i][0], faceContour[i][1]);
      ctx.lineTo(faceContour[i + 1][0], faceContour[i + 1][1]);
      ctx.stroke();
    }
  }

  // Drawing Brightness Bar
  drawBrightnessBar(canvasElement, ctx, lightingScore, previousLightingScore);

  //counter on canvas
  ctx.fillStyle = "#fff";
  ctx.textAlign = "center";
  ctx.font = "24px century-gothic";
  ctx.fillText(
    counter ? counter : "",
    canvasElement.width / 2,
    landscapeMode ? canvasElement.height * 0.06 : canvasElement.height * 0.13
  );

  if (faceContour) {
    const dummyCanvas = document.createElement("canvas");
    dummyCanvas.width = fixedCanvasWidth;
    dummyCanvas.height = fixedCanvasHeight;
    const dmctx = dummyCanvas.getContext("2d");
    dmctx.save(); // Save the current state

    dmctx.scale(-1, 1); // Set scale to flip the image
    dmctx.drawImage(webcamElement, 0, 0, fixedCanvasWidth * -1, fixedCanvasHeight);
    dmctx.restore(); // Restore the last saved state
    return await calculateLuminosity(dmctx, faceContour, lightingScore, previousLightingScore);
  } else {
    return null;
  }
};

export { drawContours };
